const REQUEST_RESPONSE_TIME = 'platfi-ui-app/DASHBOARD/REQUEST_RESPONSE_TIME';
const REQUEST_RESPONSE_TIME_SUCCESS = 'platfi-ui-app/DASHBOARD/REQUEST_RESPONSE_TIME_SUCCESS';
const REQUEST_RESPONSE_TIME_FAILURE = 'platfi-ui-app/DASHBOARD/REQUEST_RESPONSE_TIME_FAILURE';

export { REQUEST_RESPONSE_TIME, REQUEST_RESPONSE_TIME_SUCCESS, REQUEST_RESPONSE_TIME_FAILURE };
